export const parseTextareaEntries = (value: string): string[] =>
  value
    .split(/\r?\n|,/) // allow comma or newline separation
    .map(entry => entry.trim())
    .filter(Boolean)
